/* eslint-disable @angular-eslint/no-input-rename */
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ami-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ami-alert.component.html',
  styleUrl: './ami-alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AmiAlertComponent {
  @Input({ required: true }) set message(value: string | null) {
    if (!value)
      return;

    this._message.set(value);
  }

  _message = signal<string | null>(null);

  @Input({ required: false }) set style(value: string | null) {
    if (!value)
      return;

    this._style.set(value);
  }

  _style = signal<string | null>(null);

  @Input({ required: false }) set useSmallIcon(value: boolean) {
    this._useSmallIcon.set(value);
  }

  _useSmallIcon = signal<boolean>(false);
}
